import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-dbsize',
  templateUrl: './dbsize.component.html',
  styleUrls: ['./dbsize.component.css']
})


export class DbsizeComponent  extends BaseComponent implements OnInit {
  constructor(injector: Injector) { super(injector) }
  result: any = {}
  async ngOnInit() {

    this.result = await this.db.get("authenticate","getdbsize")


  }
}
